module.exports = __webpack_public_path__ + "img/brazil-logo-icon.718edb64.png";